import React from 'react';
import PropTypes from 'prop-types';
import ResumeHeader from './_Header';
import ResumeSummary from './_Summary';
import ResumeExperience from './_Experience';
import ResumeEducation from './_Education';
import ResumeRatings from './_Ratings';
import Seo from '../../components/Seo';

const Resume = props => {
  const pageSeo = {
    type: 'WebPage',
    title: "Jody Boucher's Resume",
    description: "Read and download Jody's Resume.",
  };
  const pagePath = props.location.pathname;

  return (
    <article className="resume-container">
      <Seo pageSeo={pageSeo} pagePath={pagePath} />
      <div className="resume-wrapper resume-content">
        <header className="site-page--header">
          <h1 className="site-page--title">Resume</h1>
        </header>
        <ResumeHeader />
        <ResumeSummary />
        <ResumeExperience />
        <ResumeEducation />
      </div>
      <div className="resume-sidebar">
        <aside className="resume--aside">
          <div className="resume-wrapper">
            <ResumeRatings />
          </div>
        </aside>
      </div>
    </article>
  );
};

Resume.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Resume;



// WEBPACK FOOTER //
// ./src/pages/resume/index.js